import {invert} from 'lodash';

import {ActionWithPayload} from '../../../../../helpers/reduxHelpers';
import {AppAction} from '../../../../appActions';
import {PanelActionPayload} from '../../../panelsActions';
import {ContactsManagerPanelId} from '../../../panelStateBase';
import {ContactsManagerParameters} from '../parameters/contactsManagerParameters';

/*
 * Type enum.
 */

export enum ContactsManagerRoutingActionsEnum {
  NAVIGATED = '@@panels/contactsManager/routing/NAVIGATED',
}

/*
 * Types.
 */

type ContactsManagerPanelActionPayload = PanelActionPayload<ContactsManagerPanelId>;
interface ContactsManagerRouteNavigatedActionPayload extends ContactsManagerPanelActionPayload {
  parameters: ContactsManagerParameters;
}

interface ContactsManagerRouteNavigatedAction
  extends ActionWithPayload<ContactsManagerRouteNavigatedActionPayload> {
  type: ContactsManagerRoutingActionsEnum.NAVIGATED;
}

/*
 * Action creators.
 */

export function contactsManagerNavigatedAction(
  panelId: ContactsManagerPanelId,
  parameters: ContactsManagerParameters,
): ContactsManagerRouteNavigatedAction {
  return {
    type: ContactsManagerRoutingActionsEnum.NAVIGATED,
    payload: {panelId, parameters},
  };
}

/*
 * Union type.
 */

export type ContactsManagerRoutesAction = ContactsManagerRouteNavigatedAction;

/*
 * Type guards.
 */

const routeActionsEnumMap = invert(ContactsManagerRoutingActionsEnum);
export function actionIsRouteAction(action: AppAction): action is ContactsManagerRoutesAction {
  return action.type in routeActionsEnumMap;
}
